




























import Vue from 'vue';

export default Vue.extend({
  name: 'CritterMonthNavbar',
  props: {
    currentMonth: {
      type: Number,
      default: () => new Date().getMonth(),
    },
  },
  data() {
    return {
      month: this.currentMonth,
    };
  },
  methods: {
    prevMonth() {
      this.month < 1 ? (this.month += 11) : (this.month -= 1);
      this.$emit('changeMonth', this.month);
    },
    nextMonth() {
      this.month >= 11 ? (this.month -= 11) : (this.month += 1);
      this.$emit('changeMonth', this.month);
    },
  },
});
